import { render, staticRenderFns } from "./Accounting.vue?vue&type=template&id=c94496b2&scoped=true"
import script from "./Accounting.vue?vue&type=script&lang=js"
export * from "./Accounting.vue?vue&type=script&lang=js"
import style0 from "./Accounting.vue?vue&type=style&index=0&id=c94496b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94496b2",
  null
  
)

export default component.exports